"use client";

import { useEffect, useState } from "react";
import { messaging, getToken, onMessage } from "@/lib/firebase";
import { useNotification } from "@/contexts/NotificationContext";

export const useFirebaseNotifications = () => {
  const [fcmToken, setFcmToken] = useState("");
  const [permission, setPermission] = useState("default");
  const { success, info, warning, error } = useNotification();

  useEffect(() => {
    if (typeof window === "undefined" || !messaging) return;

    const requestPermission = async () => {
      try {
        // Register service worker first
        if ("serviceWorker" in navigator) {
          const registration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js",
            {
              scope: "/",
            },
          );

          // Wait for service worker to be ready
          await navigator.serviceWorker.ready;
        }

        const permission = await Notification.requestPermission();
        setPermission(permission);

        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY ||
              "BJmBrx0yWHGyaZKLtUL32-DzWlLCZucbhmguKtjDnXXei2Lapx9SpDCZrfrb9f-07LjNhNrNCtVJYKcSQyG30b0",
            serviceWorkerRegistration:
              await navigator.serviceWorker.getRegistration(
                "/firebase-messaging-sw.js",
              ),
          });

          if (token) {
            setFcmToken(token);
            await saveFCMToken(token);

            const checkAndSaveToken = () => {
              const authToken = localStorage.getItem("token");
              if (authToken) {
                saveFCMToken(token);
              } else {
                setTimeout(checkAndSaveToken, 1000);
              }
            };

            setTimeout(checkAndSaveToken, 1000);
          }
        }
      } catch (error) {
      }
    };

    const saveFCMToken = async (token) => {
      try {
        const authToken = localStorage.getItem("token");
        if (!authToken) return;

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_END_POINT}/users/fcm-token`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ fcmToken: token }),
          },
        );

        await response.json();
      } catch (error) {
      }
    };

    const unsubscribe = onMessage(messaging, (payload) => {
      const { notification, data } = payload;

      const notificationType = data?.type || "info";
      const message = notification?.body || "New notification";

      try {
        switch (notificationType) {
          case "doctor_request":
            info && info(message, { duration: 10000 });
            break;
          case "donor_allotted":
            success && success(message, { duration: 10000 });
            break;
          case "donor_rejected":
            warning && warning(message, { duration: 10000 });
            break;
          case "document_uploaded":
            info && info(message, { duration: 10000 });
            break;
          case "process_completed":
            success && success(message, { duration: 10000 });
            break;
          default:
            info && info(message, { duration: 10000 });
        }
      } catch (error) {
      }
    });

    requestPermission();

    return () => {
      unsubscribe();
    };
  }, [success, info, warning, error]);

  const saveTokenManually = async () => {
    if (fcmToken) {
      const authToken = localStorage.getItem("token");
      if (!authToken) return;

      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_END_POINT}/users/fcm-token`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ fcmToken: fcmToken }),
          },
        );

        await response.json();
      } catch (error) {
      }
    }
  };

  return { fcmToken, permission, saveTokenManually };
};
